import { useState, useEffect } from 'react';
import _get from 'lodash-es/get';
import useInterval from './useInterval';
import zfetch, { METHOD_GET } from './zfetch';
import { genericErrorMsg } from '../../../constants';

const useReportsPolling = ({
  reportID = '',
  frequency = 2,
  isPollingStarted = false,
  onResponse,
  url = '',
}) => {
  const [freq, setFrequency] = useState(frequency);

  const fetchData = async () => {
    let isError = false;
    let message;

    const response = await zfetch(url, {
      method: METHOD_GET,
      params: { report_id: reportID },
    })
      .then(res => res.json())
      .catch(async err => {
        if (err.response) {
          await err.response.json().then(e => {
            message = _get(e, 'message', genericErrorMsg);
          });
        }
        isError = true;
      });

    const returnPayload = !isError
      ? { isError: false, response }
      : { isError: true, message };

    onResponse(returnPayload);
  };

  useInterval(isPollingStarted, fetchData, !freq ? null : freq * 1000);

  useEffect(() => setFrequency(frequency), [frequency, reportID]);
};

export default useReportsPolling;
